import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IChecklistItemCompleted } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ChecklistItemCompletedService extends BaseService<IChecklistItemCompleted> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'checklistItemCompleted');
  }
}

export { IChecklistItemCompleted } from '../shared/api';
